export default (api) => ({
    list: (params) => api.get('/projects', { params }),
    create: (params) => api.post('/projects', params),
    get: ({ projectId }) => api.get(`/projects/${projectId}`),
    delete: ({ projectId }) => api.delete(`/projects/${projectId}`),
    update: ({ projectId, params }) => api.put(`/projects/${projectId}`, params),
})
